// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerLayoutStyles } from "@steiner/App/Components/Header/HeaderLayout";
import { HEADER_BREAKPOINT } from "@steiner/Overrides/Pages/Header";
import { DivWrapper } from "@steiner/XDL/constants";
import { color, layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

headerLayoutStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 223px 1fr auto auto;
        grid-template-rows: auto;
        gap: 12px 64px;
        ${layoutContainer}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            gap: 8px;
            grid-template-columns: 1fr;
            grid-template-rows: auto;

            // For sticky style
            position: relative;
            padding-top: 45px;
            &.str-header-sticky {
                padding-top: 84px;
                .search-sticky {
                    position: fixed;
                    width: 100%;
                    top: 45px;
                    left: 0;
                    z-index: 10;
                    background: ${color("common.ui8")};
                    box-shadow: 0 0 0 100vmax ${color("common.ui8")};
                    clip-path: inset(0 -100vmax);
                    ${layoutContainer}
                }
            }
        }
    `,
};

headerLayoutStyles.logoWrapper = {
    css: css`
        grid-area: 1 / 1 / 1 / 2;
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            grid-area: 2 / 1 / 3 / 2;
            margin: auto;
        }
    `,
};

headerLayoutStyles.searchMenuWrapper = {
    css: css`
        grid-area: 1 / 2 / 1 / 4;
        display: flex;
        align-items: center;
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            grid-area: 4 / 1 / 5 / 2;
            padding-bottom: 4px;
        }
    `,
};

headerLayoutStyles.actionsWrapper = {
    css: css`
        grid-area: 1 / 4 / 1 / 5;
        display: flex;
        align-items: center;
        gap: 20px;

        & > div.mainNavigation-wrapper {
            display: none;
        }

        ${({ isInShell }: any) =>
            !isInShell &&
            css`
                ${xScreen("lte", HEADER_BREAKPOINT)} {
                    gap: 12px;
                    grid-area: 1 / 1 / 2 / 2;
                    justify-content: space-between;
                    padding: 6px 0;
                    background: ${color("common.ui8")};
                    box-shadow: 0 0 0 100vmax ${color("common.ui8")};
                    clip-path: inset(0 -100vmax);

                    & > div.mainNavigation-wrapper {
                        display: block;
                    }
                    & > div.extraMenu-wrapper {
                        display: none;
                    }

                    &.action-sticky {
                        height: 45px;
                        width: 100%;
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        z-index: 10;
                        ${layoutContainer}
                    }
                }
            `}
    `,
};

headerLayoutStyles.secondaryMainNavigation = {
    css: css`
        grid-area: 3 / 1 / 4 / 2;

        ${({ isInShell }: any) =>
            !isInShell &&
            css`
                display: none;
                ${xScreen("lte", HEADER_BREAKPOINT)} {
                    display: block;
                }
            `}
    `,
};

headerLayoutStyles.mainNavigationWrapper = {
    css: css`
        grid-area: 2 / 1 / 2 / 3;
        padding: 5px 0;

        ${({ isInShell }: any) =>
            !isInShell &&
            css`
                ${xScreen("lte", HEADER_BREAKPOINT)} {
                    display: none;
                }
            `}
    `,
};

headerLayoutStyles.linkListWrapper = {
    css: css`
        position: relative;
        top: 0;
        display: flex;
        grid-area: 2 / 3 / 2 / 5;
        justify-content: flex-end;
        & > ${DivWrapper} {
            display: flex;
            align-items: center;
        }

        ${({ isInShell }: any) =>
            !isInShell &&
            css`
                box-shadow: 100vmax 0 0 100vmax ${color("common.ui6")};
                clip-path: inset(0 -100vmax);
                background: linear-gradient(
                    to right,
                    transparent,
                    transparent 90%,
                    ${color("common.ui6")} 90%,
                    ${color("common.ui6")} 100%
                );

                & > ${DivWrapper} {
                    background: ${color("common.ui6")};
                    clip-path: polygon(8px 0, 100% 0, 100% 100%, 0 100%);
                }

                ${xScreen("lte", HEADER_BREAKPOINT)} {
                    display: none;
                }
            `}
    `,
};
